import axios from 'axios';
import { message, Modal } from 'antd';
import store from '../store'
import { isAndroid, isIOS, storage, encryptText, decryptText } from '@/utils';

const baseURL = window.location.origin + '/irpas/rest'

const $req = axios.create({
  baseURL,
  timeout: 60000, // 文件下载接口有时太慢，先改长一点
  headers: {
    'Content-Type': 'application/json;chartset=UTF-8'
  }
})

const isMobileAndBroswer = window.innerWidth <= 768
const isMobile = navigator.userAgent.includes('AIA-Mobile')

export function modalContent(iconPath, text) {
  return (
    <div className='warning-modal-content'>
      <div className='content-icon'>
        <img src={iconPath} alt='ICON' />
      </div>
      {
        typeof text === 'string' ?
        <div className='content-text' style={{fontFamily: isMobileAndBroswer ? 'Open Sans SemiBold' : 'Open Sans'}}>{text}</div> :
        text.map((item, index) => (
          <div className='content-text' key={index} style={{fontFamily: isMobileAndBroswer ? 'Open Sans SemiBold' : 'Open Sans'}}>{item}</div>
        ))
      }
    </div>
  )
}

export function closeIcon() {
  return (
    <img src={require('@/assets/img/icon/icon_close.png')}></img>
  )
}

$req.interceptors.request.use((config) => {

  const { language } = store.getState('language')
  // debugger
  const accessToken = storage.getItem('accessToken') === 'undefined' ? '' :  decryptText('accessToken')
  if (accessToken) config.headers.accessToken = accessToken;

  const sessionToken = storage.getItem('sessionToken') === 'undefined' ? '' : decryptText('sessionToken')
  if (sessionToken) config.headers.sessionToken = sessionToken;

  const androidVersion = storage.getItem('androidVersion', 'l') === 'undefined' ? '' :  decryptText('androidVersion', 'l')
  if (androidVersion && isAndroid()) config.headers.androidVersion = androidVersion;

  const iosVersion = storage.getItem('iosVersion', 'l') === 'undefined' ? '' : decryptText('iosVersion', 'l')
  if (iosVersion && isIOS()) config.headers.iosVersion = iosVersion;

  config.data = Object.assign(config.data || {}, { lang: language })

  return config;
}, (error) => {
  message.error(error);
  return Promise.reject(error);
})

$req.interceptors.response.use((response) => {
  const { language } = store.getState('language');

  const res = response.data;
  const disposition = response.headers['content-disposition']
  console.log(process.env)

  // console.log(response.config.url + ' =========== ' + response.headers.accesstoken)
  // 每次请求都会返回新token
  if (response.headers['accesstoken']) {
    // console.log('==========================设置新的token==========================')
    // storage.setItem('accessToken', response.headers.accesstoken)
    encryptText('accessToken', response.headers.accesstoken)
  }

  if (response.headers['sessiontoken']) {
    if (isMobile) {
      if (isAndroid()) {
        window.sentToAndroid.saveToken(JSON.stringify({
          sessionToken: response.headers.sessiontoken
        }))
      }

      if (isIOS()) {
        window.webkit.messageHandlers.WKNativeMethodMessage.postMessage({
          sessionToken: response.headers.sessiontoken,
          isUpdateToken: true
        })
      }
    } else {
      // storage.setItem('sessionToken', response.headers.sessiontoken)
      encryptText('sessionToken', response.headers.sessiontoken)
    }
  }

  // 登录及修改密码成功后要存token
  if (loginUrls.includes(response.config.url) && res.resultCode === '0') {
    // storage.setItem('accessToken', res.accessToken)
    // storage.setItem('sessionToken', res.sessiontoken)
    encryptText('accessToken', res.accessToken)
    encryptText('sessionToken', res.sessiontoken)
  }

  if (res.resultCode && (res.resultCode === '401' || res.resultCode === '601')) { // accessToken and sessionToken 过期都走这里
    if (!isShow401Modal) {
      // 展示弹窗回到登录页
      Modal.error({
        className: `warning-modal`,
        centered: true,
        closable: false,
        closeIcon: closeIcon(),
        width: !isMobileAndBroswer ? 640 : 360,
        maskClosable:false,
        content: modalContent(require('@/assets/img/icon/icon_warning.png'), language === 'en' ? 'Session timeout' :  'Session timeout'),
        onOk: () => {
          // console.log('点击了ok')
          isShow401Modal = false
          if (isMobile) {
            // 手机app访问
            if (isIOS()) {
              window.webkit.messageHandlers.WKNativeMethodMessage.postMessage({
                // isLogout: true,
                tokenInvaliadCode: res.resultCode
              })
            } else if (isAndroid()) {
              window.sentToAndroid.handleSessionTimeout(JSON.stringify({
                // isLogout: 'Y',
                tokenInvaliadCode: res.resultCode
              }))
            }
          } else {
            // 手机浏览器访问
            // console.log('手机浏览器访问')
            const userType = decryptText('irpas_userType')
            window.sessionStorage.clear()
            if (userType === 'ee') {
              window.location.pathname = `/${process.env.REACT_APP_CONTEXT_PATH}/eelogin`
            } else if (userType === 'er') {
              window.location.pathname = `/${process.env.REACT_APP_CONTEXT_PATH}/erlogin`
            }
          }
        }
      })
    }
    isShow401Modal = true
  } else if (res.resultCode === '600') {
    const index = res.resultMessage.indexOf('\n')
    const text1 = res.resultMessage.slice(0, 43)
    const text2 = res.resultMessage.slice(index + 1)
    Modal.error({
      className: `warning-modal warning-modal2`,
      centered: true,
      closable: false,
      closeIcon: closeIcon(),
      width: !isMobileAndBroswer ? 640 : 360,
      maskClosable:false,
      content: modalContent(require('@/assets/img/icon/icon_warning.png'), [text1, text2]),
      onOk: () => {
        // console.log('点击了ok')
        if (isMobile) {
          // 手机app访问
          if (isIOS()) {
            window.webkit.messageHandlers.WKNativeMethodMessage.postMessage({
              // isLogout: true,
              tokenInvaliadCode: '601'
            })
          } else if (isAndroid()) {
            window.sentToAndroid.handleSessionTimeout(JSON.stringify({
              // isLogout: 'Y',
              tokenInvaliadCode: '601'
            }))
          }
        } else {
          // 手机浏览器访问
          // console.log('手机浏览器访问')
          const userType = decryptText('irpas_userType')
          window.sessionStorage.clear()
          if (userType === 'ee') {
            window.location.pathname = `/${process.env.REACT_APP_CONTEXT_PATH}/eelogin`
          } else if (userType === 'er') {
            window.location.pathname = `/${process.env.REACT_APP_CONTEXT_PATH}/erlogin`
          }
        }
      }
    })
  } else if (res.resultCode && res.resultCode === '402') { // 登录的时候密码错误弹框
      Modal.error({
        className: `warning-modal${!isMobileAndBroswer ? ' warning-modal-no-btn' : ''}`,
        centered: true,
        closable: true,
        closeIcon: closeIcon(),
        width: 640,
        maskClosable:false,
        content: modalContent(require('@/assets/img/icon/icon_warning.png'), res.resultMessage )
      })
  }

  if (['0','1', '2','4', '3', '5', '6', '7', '8', '9', '10'].includes(res.resultCode)) {
    return res;
  } else if (!res.resultCode) {  // !res.resultCode是应对文件流返回没有resultCode
    return {
      res,
      disposition
    }
  } else if (res.resultCode === '500') { // 返回值是500时 弹出提示框
    Modal.error({
      className: `warning-modal${!isMobileAndBroswer ? ' warning-modal-no-btn' : ''}`,
      centered: true,
      closable: true,
      width: !isMobileAndBroswer ? 640 : 360,
      maskClosable:true,
      content: modalContent(require('@/assets/img/icon/icon_warning.png'), res.resultMessage),
      closeIcon: closeIcon(),
      onCancel: () => destroyAll(),
      onOk: () => destroyAll()
    })
  } else if (res.resultCode === '502') { // app version is not latest
    if (isMobile) {
      if (isIOS()) {
        window.webkit.messageHandlers.WKNativeMethodMessage.postMessage({
          isExpired: true
        })
      } else if (isAndroid()) {
        window.sentToAndroid.handleVersionExpired(JSON.stringify({
          isExpired: 'Y'
        }))
      }
    }
  }
}, (err) => {
  console.log(err)
  console.log('test log')
  console.log(window.location.origin)
  if (err.response && err.response.status === 500) {
	  Modal.error({
      className: `warning-modal${!isMobileAndBroswer ? ' warning-modal-no-btn' : ''}`,
      centered: true,
      closable: true,
      width: !isMobileAndBroswer ? 640 : 360,
      maskClosable:true,
      content: modalContent(require('@/assets/img/icon/icon_warning.png'), 'Your request cannot be handled at the moment. Please try again later.'),
      closeIcon: closeIcon(),
    })
  }

  if(err.code === 'ECONNABORTED' && err.message.includes("timeout")){
    Modal.error({
      className: `warning-modal${!isMobileAndBroswer ? ' warning-modal-no-btn' : ''}`,
      centered: true,
      closable: true,
      width: !isMobileAndBroswer ? 640 : 360,
      maskClosable:true,
      content: modalContent(require('@/assets/img/icon/icon_warning.png'), 'Your request cannot be handled at the moment. Please try again later.'),
      closeIcon: closeIcon(),
    })
  }
  return Promise.reject(err)
})

const loginUrls = [
  '/memberController/login',
  '/memberController/changePassword',
  '/employerController/login',
  '/employerController/changePassword',
]

let isShow401Modal = false

const destroyAll = () => {
  Modal.destroyAll()
}





export default $req;